import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { checkClientPackageDocuments, type ClientPackageDocumentCheckDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useCheckDocument(documentId?: number): UseQueryResult<ClientPackageDocumentCheckDto, AxiosError> {
    const queryKey = useMemo(() => queryKeys.checkDocument(documentId), [documentId]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => checkClientPackageDocuments({ path: { documentId: documentId! }, signal }).then((result) => result.data),
        enabled: !!documentId,
    });
}
